import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _slicedToArray from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { listFn, topFn, cancelFn, exportFn } from 'api/tool/message';
import { statusFilterConfig } from './config';
import addComp from './add';
import seeComp from './see';
import editComp from './edit';
import download from './download';
export default {
  props: ['category'],
  components: {
    addComp: addComp,
    seeComp: seeComp,
    editComp: editComp,
    download: download
  },
  data: function data() {
    return {
      dataForm: {
        name: '',
        updated_name: '',
        publishTimeRange: null,
        status: '' // 空=全部，1=已发布，2=已撤销
      },

      statusFilterConfig: statusFilterConfig(this),
      pageSizes: [100, 50, 20],
      page: {
        list: [],
        currPage: 1,
        limit: 20,
        total: 0
      },
      tableloading: false,
      isAdd: false,
      isSee: false,
      isEdit: false,
      isDownload: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    contentViewHeight: function contentViewHeight(state) {
      return state.settings.contentViewHeight;
    }
  })), {}, {
    tableHeight: function tableHeight(vm) {
      return vm.contentViewHeight - 265;
    }
  }),
  mounted: function mounted() {
    this.getTableList(true);
  },
  methods: {
    getTableList: function getTableList() {
      var _arguments = arguments,
        _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var isRefresh, _ref, _ref2, created_start, created_end, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              isRefresh = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;
              if (isRefresh) {
                _this.page.currPage = 1;
              }
              _this.tableloading = true;
              _ref = Array.isArray(_this.dataForm.publishTimeRange) ? _this.dataForm.publishTimeRange : [undefined, undefined], _ref2 = _slicedToArray(_ref, 2), created_start = _ref2[0], created_end = _ref2[1];
              _context.next = 6;
              return listFn({
                name: _this.dataForm.name,
                updated_name: _this.dataForm.updated_name || undefined,
                created_start: created_start,
                created_end: created_end,
                status: _this.dataForm.status || undefined,
                page: _this.page.currPage,
                page_size: _this.page.limit,
                category: _this.category
              });
            case 6:
              res = _context.sent;
              _this.tableloading = false;
              if (res && res.code === 1) {
                _this.page.list = res.data.items;
                _this.page.total = Number(res.data.pagination.total_count);
              }
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 每页条数
    sizeChangeHandle: function sizeChangeHandle(val) {
      this.page.currPage = 1;
      this.page.limit = val;
      this.getTableList();
    },
    // 切换 页
    currentChangeHandle: function currentChangeHandle(val) {
      this.page.currPage = val;
      this.getTableList();
    },
    readExport: function readExport(item) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return exportFn({
                id: item.id
              });
            case 2:
              res = _context2.sent;
              if (res && res.code === 1) window.open(res.data.object_url);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    add: function add() {
      var _this2 = this;
      this.isAdd = true;
      this.$nextTick(function () {
        return _this2.$refs.add.init();
      });
    },
    see: function see(item) {
      var _this3 = this;
      this.isSee = true;
      this.$nextTick(function () {
        return _this3.$refs.see.init(item);
      });
    },
    edit: function edit(item) {
      var _this4 = this;
      this.isEdit = true;
      this.$nextTick(function () {
        return _this4.$refs.edit.init(item);
      });
    },
    topHandle: function topHandle(item) {
      var _this5 = this;
      var text = item.is_top === '0' ? this.$t('233') : this.$t('1463');
      this.$confirm(text, this.$t('870'), {
        distinguishCancelAndClose: true,
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      }).then(function () {
        topFn({
          id: item.id,
          is_top: Number(!Number(item.is_top))
        }).then(function (res) {
          if (res && res.code === 1) {
            _this5.$message.success('success');
            _this5.getTableList();
          }
        });
      });
    },
    // 下载
    downloadHandle: function downloadHandle(item) {
      var _this6 = this;
      this.isDownload = true;
      this.$nextTick(function () {
        return _this6.$refs.download.init(item);
      });
    },
    cancelHandle: function cancelHandle(item) {
      var _this7 = this;
      this.$confirm(this.$t('232'), this.$t('870'), {
        distinguishCancelAndClose: true,
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      }).then(function () {
        cancelFn({
          id: item.id
        }).then(function (res) {
          if (res && res.code === 1) {
            _this7.$message.success('success');
            _this7.getTableList();
          }
        });
      });
    }
  }
};